export default __webpack_public_path__ + "static/media/modiji.0bf0cdba.png";